import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import "./App.css";

import SiteLayout from "./components/site/SiteLayout";
import Home from "./pages/Home";
import About from "./pages/About";
import ServicePage from "./pages/ServicePage";
import Work from "./pages/Work";
import WorkDetail from "./pages/WorkDetail";
import SocialImpactPage from "./pages/SocialImpactPage";
import PartnersPage from "./pages/PartnersPage";
import Careers from "./pages/Careers";
import Contact from "./pages/Contact";
import Legal from "./pages/Legal";
import Admin from "./pages/Admin";
import NotFound from "./pages/NotFound";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<SiteLayout />}>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/services/:slug" element={<ServicePage />} />
          <Route path="/work" element={<Work />} />
          <Route path="/work/:slug" element={<WorkDetail />} />
          <Route path="/social-impact" element={<SocialImpactPage />} />
          <Route path="/partners" element={<PartnersPage />} />
          <Route path="/careers" element={<Careers />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/legal/:slug" element={<Legal />} />
          <Route path="*" element={<NotFound />} />
        </Route>
        <Route path="/admin" element={<Admin />} />
      </Routes>
      <Toaster
        position="bottom-right"
        toastOptions={{
          style: {
            background: "#0E0D14",
            color: "#F7F6F2",
            border: "1px solid rgba(216,183,122,0.35)",
            borderRadius: "14px",
            fontFamily: "Manrope, sans-serif",
            fontSize: "14px",
            letterSpacing: "-0.005em",
          },
        }}
      />
    </BrowserRouter>
  );
}

export default App;
